import {createReducer} from '../utils';
import {default as types} from '../constants';

const initialState = {
	models: []
};

export default createReducer(initialState, {
	[types.FETCH_SAMPLE_HARDENINGS_REQUEST]: (state, payload) => {
		return Object.assign({}, state, {
			'models': payload.samples,
		});
  }
});



/** WEBPACK FOOTER **
 ** ./js/reducers/sample-hardening.js
 **/